import { signOut } from 'firebase/auth';

import { auth } from '../../';

export const signOutUser = async (navigate) => {
  try {
    localStorage.removeItem('sessionToken');
    await signOut(auth);
    navigate('/');
  } catch (error) {
    console.error(error);
  }
};
